import React from "react";
import { NotificationPreferencesForm } from "../components/Elements/NotificationPreferencesForm";

export const NotificationPreferences: React.FC = () => {
  return <NotificationPreferencesForm />;
};
